import React, { Component } from 'react'
import {FormattedMessage} from 'react-intl';
import QRGenerator from "./QRGenerator";
import ConfigBusiness from "../../commons/config/ConfigBusiness.js";

class ReportarIncidente extends Component {
    render() {
        return (
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-md-6 col-12 mb-2">
                        <h3 className="content-header-title"><FormattedMessage id="ReportarIncidente.Administracion_de_Reportes_de_Incidentes" defaultMessage="Administración de Reportes de Incidentes"/></h3>
                    </div>
                </div>
                <div className="content-body">
                    {ConfigBusiness.get("reportarIncidentes.habilitado") === "true" ?
                        <QRGenerator />
                    : ''}
                </div>
            </div>
        );
    }
}

export default ReportarIncidente;